import { render, staticRenderFns } from "./FieldLayout.vue?vue&type=template&id=88936bb2&scoped=true&"
import script from "./FieldLayout.vue?vue&type=script&lang=js&"
export * from "./FieldLayout.vue?vue&type=script&lang=js&"
import style0 from "./FieldLayout.vue?vue&type=style&index=0&id=88936bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88936bb2",
  null
  
)

export default component.exports